import React, {FunctionComponent, useMemo} from "react";
import {Grid} from "@mui/material";
import EnergySavingsLeafOutlined from "@mui/icons-material/EnergySavingsLeafOutlined";
import BatteryChargingFullOutlined from "@mui/icons-material/BatteryChargingFullOutlined";
import StackedLineChartOutlined from "@mui/icons-material/StackedLineChartOutlined";
import SpeedOutlined from "@mui/icons-material/SpeedOutlined";
import DailyReportTotalizerCard from "../../../../../../Shared/Components/DailyReportTotalizerCard/DailyReportTotalizerCard";
import {useAppSelector} from "../../../../../../Config/Hooks";
import {RootState} from "../../../../../../Config/Store";
import {FindInverterIndicatorsByEquipmentId, InstantInfoValue} from "../../InverterReactQuery";
import {formatInstantInfoValueParts} from "../InstantInfoSection/instantInfoModel";
import {TELE_OBJECT_DATA_TYPE_ID} from "../../../../../../Shared/Types/TeleObjectDataTypeId";

export interface InverterGenerationTotalizersProps {
    equipmentId: number;
    powerStationId: number | undefined;
}

interface GenerationCardConfig {
    key: string;
    icon: React.ReactNode;
    color: string;
    title: string;
    teleObjectDataTypeId: number;
}

const GENERATION_CARDS: GenerationCardConfig[] = [
    {key: "active-power", icon: <EnergySavingsLeafOutlined/>, color: "#0AAD6F", title: "Potência Ativa", teleObjectDataTypeId: TELE_OBJECT_DATA_TYPE_ID.ACTIVE_POWER},
    {key: "daily-energy", icon: <BatteryChargingFullOutlined/>, color: "#2D5DE7", title: "Energia Diária", teleObjectDataTypeId: TELE_OBJECT_DATA_TYPE_ID.EXPORTED_ENERGY},
    {key: "total-energy", icon: <StackedLineChartOutlined/>, color: "#E59338", title: "Energia Total", teleObjectDataTypeId: TELE_OBJECT_DATA_TYPE_ID.TOTAL_GENERATION},
    {key: "efficiency", icon: <SpeedOutlined/>, color: "#5C6BC0", title: "Eficiência", teleObjectDataTypeId: TELE_OBJECT_DATA_TYPE_ID.EFFICIENCY},
];

const InverterGenerationTotalizers: FunctionComponent<InverterGenerationTotalizersProps> = ({
                                                                                                  equipmentId,
                                                                                                  powerStationId,
                                                                                              }) => {
    const userConfig = useAppSelector((state: RootState) => state.userConfigurarion);

    const indicatorsQuery = FindInverterIndicatorsByEquipmentId(
        equipmentId,
        powerStationId,
        userConfig.mainUpdateInterval
    );

    const isLoading = equipmentId > 0 && !!powerStationId && indicatorsQuery.isLoading;
    const indicatorsList = indicatorsQuery.data?.data;

    const indicatorsByDataTypeId = useMemo(() => {
        const map = new Map<number, InstantInfoValue>();
        indicatorsList?.forEach((item: InstantInfoValue) => {
            if (item.teleObjectDataTypeId != null) {
                map.set(item.teleObjectDataTypeId, item);
            }
        });
        return map;
    }, [indicatorsList]);

    const cards = useMemo(
        () =>
            GENERATION_CARDS.map((card) => {
                const item = indicatorsByDataTypeId.get(card.teleObjectDataTypeId);
                const {value, unit} = item
                    ? formatInstantInfoValueParts(item)
                    : {value: "-", unit: ""};
                return {...card, value, unit};
            }),
        [indicatorsByDataTypeId]
    );

    return (
        <Grid container spacing={2}>
            {cards.map((card) => (
                <Grid item xs={12} sm={6} md={3} key={card.key}>
                    <DailyReportTotalizerCard
                        icon={card.icon}
                        color={card.color}
                        title={card.title}
                        value={card.value}
                        unit={card.unit}
                        loading={isLoading}
                        showViewIcon
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default InverterGenerationTotalizers;
